// ============================================================
// Bouton toggle dark/light
// ============================================================

import { useTheme } from './ThemeProvider';

export function ThemeToggle(): JSX.Element {
  const { theme, toggle } = useTheme();
  const label = theme === 'dark' ? 'Passer en clair' : 'Passer en sombre';
  const icon = theme === 'dark' ? '☀' : '☾';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      style={{
        background: 'var(--color-surface)',
        color: 'var(--color-text)',
        border: '1px solid var(--color-border)',
        borderRadius: '8px',
        padding: '8px 12px',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontSize: '14px',
      }}
    >
      {icon} {theme === 'dark' ? 'Sombre' : 'Clair'}
    </button>
  );
}
